/* eslint-disable */

import { NavLink, useLocation } from 'react-router-dom';
// chakra imports
import {
	Box,
	Collapse,
	Flex,
	HStack,
	Icon,
	Text,
	useColorModeValue,
	useDisclosure,
} from '@chakra-ui/react';
import { MdExpandLess, MdExpandMore, MdInventory, MdSettings } from 'react-icons/md';

// AUTH
import { useAuth, userIsProcura } from "contexts/AuthProvider";

export function SidebarLinks(props: {
	routes: RoutesType[];
}) {
	//   Chakra color mode
	let location = useLocation();
	let activeColor = useColorModeValue('gray.700', 'white');
	let inactiveColor = useColorModeValue('secondaryGray.600', 'secondaryGray.600');
	let activeIcon = useColorModeValue('brand.500', 'white');
	let textColor = useColorModeValue('secondaryGray.500', 'white');
	let brandColor = useColorModeValue('brand.500', 'brand.400');

	const { routes } = props;
	const { user } = useAuth();
	const { isOpen: configOpen, onToggle: toggleConfig } = useDisclosure();
	const { isOpen: maestrosOpen, onToggle: toggleMaestros } = useDisclosure();
	const deviationCategoriesActive = location.pathname.includes(
		"/coverage/deviation-categories"
	);
	const productsActive = location.pathname.includes('/masters/products');
	const suppliersActive = location.pathname.includes('/masters/suppliers');
	const showProcuraConfig = userIsProcura(user);

	// verifies if routeName is the one active (in browser input)
	const activeRoute = (routeName: string) => {
		return location.pathname.includes(routeName);
	};

	const userHasAccess = (route: RoutesType) => {
		return user.canAccessModule(route.moduleName)
	}

	// this function creates the links from the secondary accordions (for example auth -> sign-in -> default), based of user permissions
	const createLinks = (
		routes: RoutesType[],
	) => {
		return routes.map(
			(
				route: RoutesType,
				index: number
			) => {
				if (route.layout && userHasAccess(route)) {
					return (
						<NavLink key={index} to={route.layout + route.path}>
							{route.icon ? (
								<Box>
									<HStack
										spacing={activeRoute(route.path.toLowerCase()) ? '22px' : '26px'}
										py='5px'
										ps='10px'>
										<Flex w='100%' alignItems='center' justifyContent='center'>
											<Box
												color={activeRoute(route.path.toLowerCase()) ? activeIcon : textColor}
												me='18px'>
												{route.icon}
											</Box>
											<Text
												me='auto'
												color={activeRoute(route.path.toLowerCase()) ? activeColor : textColor}
												fontSize={'14px'}
												fontWeight={activeRoute(route.path.toLowerCase()) ? 'bold' : 'normal'}>
												{route.name}
											</Text>
										</Flex>
										<Box
											h='36px'
											w='4px'
											bg={activeRoute(route.path.toLowerCase()) ? brandColor : 'transparent'}
											borderRadius='5px'
										/>
									</HStack>
								</Box>
							) : (
								<Box>
									<HStack
										spacing={activeRoute(route.path.toLowerCase()) ? '22px' : '26px'}
										py='5px'
										ps='10px'>
										<Text
											me='auto'
											color={activeRoute(route.path.toLowerCase()) ? activeColor : inactiveColor}
											fontSize={'14px'}
											fontWeight={activeRoute(route.path.toLowerCase()) ? 'bold' : 'normal'}>
											{route.name}
										</Text>
										<Box h='36px' w='4px' bg='brand.400' borderRadius='5px' />
									</HStack>
								</Box>
							)}
						</NavLink>
					);
				}
			}
		);
	};
	const configSectionOpen = configOpen || deviationCategoriesActive;
	const maestrosSectionOpen =
		maestrosOpen || productsActive || suppliersActive;

	//  BRAND
	return (
		<>
			{createLinks(routes)}
			<Box>
				<Box
					onClick={toggleMaestros}
					cursor="pointer"
					role="button"
					aria-expanded={maestrosSectionOpen}
					tabIndex={0}
					onKeyDown={(e) => {
						if (e.key === 'Enter' || e.key === ' ') {
							e.preventDefault();
							toggleMaestros();
						}
					}}>
					<HStack spacing={maestrosSectionOpen ? '22px' : '26px'} py="5px" ps="10px">
						<Flex w="100%" alignItems="center">
							<Box color={maestrosSectionOpen ? activeIcon : textColor} me="18px">
								<Icon as={MdInventory} w="20px" h="20px" />
							</Box>
							<Text
								me="auto"
								color={maestrosSectionOpen ? activeColor : textColor}
								fontSize="14px"
								fontWeight={maestrosSectionOpen ? 'bold' : 'normal'}>
								Maestros
							</Text>
							<Icon
								as={maestrosSectionOpen ? MdExpandLess : MdExpandMore}
								color={textColor}
								w="18px"
								h="18px"
							/>
						</Flex>
						<Box h="36px" w="4px" bg="transparent" borderRadius="5px" />
					</HStack>
				</Box>
				<Collapse in={maestrosSectionOpen} animateOpacity>
					<NavLink to="/masters/products">
						<Box>
							<HStack
								spacing={productsActive ? '22px' : '26px'}
								py="5px"
								ps="32px">
								<Text
									me="auto"
									color={
										productsActive ? activeColor : inactiveColor
									}
									fontSize="14px"
									fontWeight={productsActive ? 'bold' : 'normal'}>
									Productos
								</Text>
								<Box
									h="36px"
									w="4px"
									bg={productsActive ? brandColor : 'transparent'}
									borderRadius="5px"
								/>
							</HStack>
						</Box>
					</NavLink>
					{/* <NavLink to="/masters/suppliers">
						<Box>
							<HStack
								spacing={suppliersActive ? '22px' : '26px'}
								py="5px"
								ps="32px">
								<Text
									me="auto"
									color={
										suppliersActive ? activeColor : inactiveColor
									}
									fontSize="14px"
									fontWeight={suppliersActive ? 'bold' : 'normal'}>
									Proveedores
								</Text>
								<Box
									h="36px"
									w="4px"
									bg={suppliersActive ? brandColor : 'transparent'}
									borderRadius="5px"
								/>
							</HStack>
						</Box>
					</NavLink> */}
				</Collapse>
			</Box>
			{showProcuraConfig ? (
				<Box>
					<Box
						onClick={toggleConfig}
						cursor="pointer"
						role="button"
						aria-expanded={configSectionOpen}
						tabIndex={0}
						onKeyDown={(e) => {
							if (e.key === 'Enter' || e.key === ' ') {
								e.preventDefault();
								toggleConfig();
							}
						}}>
						<HStack spacing={configSectionOpen ? '22px' : '26px'} py="5px" ps="10px">
							<Flex w="100%" alignItems="center">
								<Box color={configSectionOpen ? activeIcon : textColor} me="18px">
									<Icon as={MdSettings} w="20px" h="20px" />
								</Box>
								<Text
									me="auto"
									color={configSectionOpen ? activeColor : textColor}
									fontSize="14px"
									fontWeight={configSectionOpen ? 'bold' : 'normal'}>
									Configuración
								</Text>
								<Icon
									as={configSectionOpen ? MdExpandLess : MdExpandMore}
									color={textColor}
									w="18px"
									h="18px"
								/>
							</Flex>
							<Box h="36px" w="4px" bg="transparent" borderRadius="5px" />
						</HStack>
					</Box>
					<Collapse in={configSectionOpen} animateOpacity>
						<NavLink to="/coverage/deviation-categories">
							<Box>
								<HStack
									spacing={deviationCategoriesActive ? '22px' : '26px'}
									py="5px"
									ps="32px">
									<Text
										me="auto"
										color={
											deviationCategoriesActive ? activeColor : inactiveColor
										}
										fontSize="14px"
										fontWeight={deviationCategoriesActive ? 'bold' : 'normal'}>
										Desviaciones
									</Text>
									<Box
										h="36px"
										w="4px"
										bg={deviationCategoriesActive ? brandColor : 'transparent'}
										borderRadius="5px"
									/>
								</HStack>
							</Box>
						</NavLink>
					</Collapse>
				</Box>
			) : null}
		</>
	);
}

export default SidebarLinks;
